import {CardListener, NfcReader} from "@variocube/app-api";
import {CardPresented, CardRemoved, NfcReaderMessageTypes} from "@variocube/driver-common";
import {VcmpClient} from "@variocube/vcmp";
import {isThisUnit} from "./unit";

export class ControllerNfcReader implements NfcReader {

    private cardListeners = new Set<CardListener>();

    constructor(url: string) {
        const client = new VcmpClient(url);
        client.on(NfcReaderMessageTypes.CardPresented, this.handleCardPresented);
        client.on(NfcReaderMessageTypes.CardRemoved, this.handleCardRemoved);
        client.start();
    }

    addCardListener(cardListener: CardListener) {
        this.cardListeners.add(cardListener);
    }

    removeCardListener(cardListener: CardListener) {
        this.cardListeners.delete(cardListener);
    }

    private handleCardPresented = ({unit, ...cardPresented}: CardPresented) => {
        console.info("Card presented: ", {cardPresented, unit});
        if (cardPresented.uid) {
            console.log("An empty card UID was presented, ignoring");
        }
        if (!isThisUnit(unit)) {
            console.info(`Ignoring card presented from another unit: ${unit}.`);
        }
        this.cardListeners.forEach(listener => listener(cardPresented));
    };

    private handleCardRemoved = ({unit, ...cardRemoved}: CardRemoved) => {
        console.info("Card removed: ", {cardRemoved, unit});
        if (isThisUnit(unit)) {
            this.cardListeners.forEach(listener => listener());
        }
        else {
            console.info("Ignoring card removed from another unit.");
        }
    };
}
